import "./blogs-slider.css"
import 'swiper/css';
import 'swiper/css/free-mode';
import { blogSliderData } from "../../data/BlogSliderData";
import { useRef } from "react";
import { Swiper, SwiperSlide } from 'swiper/react';
import { FreeMode } from 'swiper/modules';
import BlogCard from "../blog-card/BlogCard"

function BlogsSlider() {
    const swiperRef = useRef(null);

    return (
        <div className="blogs-slider-section">
            <div className="blogs-slider-section-header">
                <h1>
                    <span className="bold">News</span> & Events
                </h1>
                <div className="blogs-slider-section-header-border"></div>
            </div>

            <div className="blogs-slider-section-buttons" >
                <div className="blogs-slider-section-button" onClick={() => swiperRef.current?.swiper?.slidePrev()}>
                    <svg xmlns="http://www.w3.org/2000/svg" width={10} height={18} viewBox="0 0 10 18" fill="none">
                        <path d="M9 1L1 9L9 17" stroke="#050320" />
                    </svg>
                </div>
                <div className="blogs-slider-section-button" onClick={() => swiperRef.current?.swiper?.slideNext()}>
                    <svg xmlns="http://www.w3.org/2000/svg" width={10} height={18} viewBox="0 0 10 18" fill="none">
                        <path d="M9 1L1 9L9 17" stroke="#050320" />
                    </svg>
                </div>
            </div>

            <Swiper
                ref={swiperRef}
                slidesPerView="auto"
                freeMode={{ enabled: false, momentum: false, sticky: false }}
                loop={blogSliderData.length >= 10 ? true : false}
                loopAdditionalSlides={3}
                speed={200}
                modules={[FreeMode]}
                watchSlidesProgress={true}
                updateOnWindowResize={true}
                grabCursor={true}
                touchRatio={1}
                simulateTouch={true}
                cssMode={false}
                className="blog-slider"
            >
                {blogSliderData.map(blog =>
                    <SwiperSlide key={blog.id}>
                        <BlogCard cardData={blog} />
                    </SwiperSlide>
                )}
            </Swiper>
        </div>
    )
}

export default BlogsSlider
